import React from 'react';

import { ChakraProvider } from '@chakra-ui/react';

import UnexpectedErrorPage, {
  UnexpectedErrorPageProps,
} from 'pages/Error/UnexpectedError';
import customTheme from 'styles/theme/customTheme';

const AppErrorFallback: React.FC<UnexpectedErrorPageProps> = (props) => {
  return (
    <ChakraProvider theme={customTheme}>
      <UnexpectedErrorPage {...props} />
    </ChakraProvider>
  );
};

export default AppErrorFallback;

export const defaultResetErrorBoundary = (): void => undefined;
